// UTM capture & persistence — thin backwards-compatible wrapper around
// `lib/clickIds.js` (PR-T1). The new module captures UTM + fbclid/gclid/ttclid
// + landing page + referrer, all under `attribution_v2` localStorage key with
// a 90-day TTL.
//
// Existing callers (`LeadForm`, `Checkout`, `ExitIntent`, `App.js`) keep using
// `captureUTM()` / `getUTM()` — they receive a backwards-compatible subset
// shape (the new fields are additive and harmless to old consumers).

import { captureAttribution, getAttribution } from "./clickIds";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function project(attr) {
  if (!attr) return null;
  const out = {};
  UTM_KEYS.forEach((k) => { if (attr[k]) out[k] = attr[k]; });
  if (attr.referrer) out.referrer = attr.referrer;
  if (attr.landing_page) out.landing_page = attr.landing_page;
  if (attr.ttclid) out.ttclid = attr.ttclid;
  return out;
}

export function captureUTM() {
  return project(captureAttribution());
}

export function getUTM() {
  return project(getAttribution());
}
